// Mirror of frontend/src/itineraryRoutes.ts so the public tour-template
// page uses the same Google Maps URL builders and per-transport-method
// labels as the in-app itinerary view. Keep the two in lockstep if either
// side changes — there's no shared package between the two React apps.

export const TRAVEL_MODE_BY_TRANSPORT: Record<string, string> = {
    drive: "driving",
    ride: "driving",
    transit: "transit",
    walk: "walking",
    cycle: "bicycling",
};

export const ROUTE_LABEL_BY_TRANSPORT: Record<string, string> = {
    drive: "Driving route",
    ride: "Riding route",
    transit: "Transit route",
    walk: "Walking route",
    cycle: "Cycling route",
};

export const routeLabel = (transportMethod?: string) =>
    ROUTE_LABEL_BY_TRANSPORT[transportMethod ?? ""] || "Driving route";

export const buildMapsLink = (
    from: string | undefined | null,
    to: string | undefined | null,
    waypoints: Array<string | undefined | null> = [],
    transportMethod: string = "drive",
): string | null => {
    const t = (to || "").trim();
    if (!t) return null;
    const f = (from || "").trim();
    const wp = waypoints
        .map((w) => (w || "").trim())
        .filter(Boolean)
        .map(encodeURIComponent)
        .join("|");
    const travelmode = TRAVEL_MODE_BY_TRANSPORT[transportMethod] || "driving";
    if (f) {
        let url = `https://www.google.com/maps/dir/?api=1&travelmode=${travelmode}&origin=${encodeURIComponent(f)}&destination=${encodeURIComponent(t)}`;
        if (wp) url += `&waypoints=${wp}`;
        return url;
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(t)}`;
};

// "Show this place" link (the 📍 map-pin button). Google Maps search.
export const buildPlaceLink = (
    query: string | undefined | null,
): string | null => {
    const q = (query || "").trim();
    if (!q) return null;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
};

// Directions to a point from the visitor's current location (the ➤ button) —
// Google Maps infers the origin when only a destination is supplied.
export const buildDirectionsFromCurrentLink = (
    to: string | undefined | null,
    transportMethod: string = "drive",
): string | null => {
    const t = (to || "").trim();
    if (!t) return null;
    const travelmode = TRAVEL_MODE_BY_TRANSPORT[transportMethod] || "driving";
    return `https://www.google.com/maps/dir/?api=1&travelmode=${travelmode}&destination=${encodeURIComponent(t)}`;
};

export const hasAccommodation = (acc: {
    title?: string;
    address?: string;
    url?: string;
    notes?: string;
} | null | undefined): boolean =>
    Boolean(acc?.title || acc?.address || acc?.url || acc?.notes);
